import { gql } from "@apollo/client"

export const GET_CLIENT_CONFIGURATION = gql`
    query clientConfiguration {
        clientConfiguration {
            reCaptchaSiteKey
        }
    }
`
